import { Injectable } from '@angular/core';
import { IGetZoneRequest } from '../public-api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from './common.service';
import { AemService } from './aem.service';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {

  constructor(private _http: HttpClient, private _commonService: CommonService, private _aemService: AemService) {
    this.setEndpoints();
    this.setSubscriptionKeys();
  }

  public endpoints: {
    landingPageEndpoint: string
  }

  private subscriptionKeys: {
    landingPageSubscriptionKey: string
  }

  private setEndpoints() {
    this.endpoints = { landingPageEndpoint: window?.['AB']?.targetedContentLandingEndpoint }
  }

  private setSubscriptionKeys() {
    this.subscriptionKeys = { landingPageSubscriptionKey: window?.['AB']?.targetedContentLandingEndpointSubkey };
  }

  private generateHttpOptions(payload: IGetZoneRequest) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': this.subscriptionKeys.landingPageSubscriptionKey,
        'zone': payload?.zone,
        'storeId': payload?.storeId,
        'banner': payload?.banner,
        'x-swy-correlation-id': this._commonService.generateUUID()
      })
    }
    return httpOptions;
  }

  public getLandingPageZoneContent(payload: IGetZoneRequest) {
    payload.screenName = 'landing-pages';
    if (!payload.cartItems) {
      delete payload.cartItems;
    }
    const httpOptions = this.generateHttpOptions(payload);
    return this._http.post(this.endpoints.landingPageEndpoint, payload, httpOptions);
  }
  
}
